import React from 'react';
import { Link } from 'react-router-dom';

import usePageMetadata from '../../hooks/usePageMetadata';
import materialPropertyGuides from './data/materialPropertyGuides';
import MaterialToolCards from './MaterialToolCards';
import './MaterialsHome.css';

const MaterialsHome = () => {
  usePageMetadata(
    'CNC Machining Material Database | ASiJoLab',
    'Explore engineering materials for CNC machining with tensile strength, thermal conductivity, elongation, chemical composition and practical machining context.'
  );

  return (
    <div className="materials-home">
      <div className="materials-home-hero">
        <section
          className="materials-home-intro"
          aria-labelledby="materials-home-title"
        >
          <p>Material database</p>
          <h1 id="materials-home-title">Material data focused on machining</h1>
          <div>
            <p>
              Material datasheets can contain a huge amount of information.
              ASiJoLab intentionally focuses on the properties that are most
              useful when deciding how a material is likely to behave during
              machining.
            </p>
            <p>
              You will not find every possible material parameter here, such as
              heat-treatment schedules, hardening temperatures or tempering
              temperatures. The goal is different: to show the data that helps
              you understand cutting behaviour, chip formation, heat, tool load
              and tool wear.
            </p>
          </div>
        </section>

      </div>

      <MaterialToolCards headingId="materials-tools-title" />

      <section
        className="material-property-overview"
        aria-labelledby="material-property-overview-title"
      >
        <div className="material-property-overview-header">
          <p>Machining context</p>
          <h2 id="material-property-overview-title">
            Understand what material properties tell you.
          </h2>
          <span>
            ASiJoLab connects material data with practical machining context,
            so the numbers on a material detail page are easier to read
            together.
          </span>
        </div>
        <div className="material-property-card-grid">
          {materialPropertyGuides.map(
            ({ slug, title, summary, machiningSummary, Icon }) => (
              <article className="material-property-card" key={slug}>
                <span className="material-property-card-icon" aria-hidden="true">
                  <Icon size={22} strokeWidth={1.9} />
                </span>
                <h3>{title}</h3>
                <p>{summary}</p>
                <p>{machiningSummary}</p>
                <Link
                  className="material-property-card-link"
                  to={`/materials/properties/${slug}`}
                >
                  Learn more
                </Link>
              </article>
            )
          )}
        </div>
      </section>
    </div>
  );
};

export default MaterialsHome;
